import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { NoPermission } from '~/components';
import { useTranslation } from 'react-i18next';
import SendMoneyView from './components/SendMoneyView';
import { Col, Row } from 'antd';
import { PageHeader } from '~/layout';
import useIsSendMoneyAvailable from '~/hooks/useIsSendMoneyAvailable';
import { usePermissions } from '~/hooks';
import { useKycCheck } from '~/hooks/kyc';
import KycContent from '../kyc/KycContent';

const SendMoney: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('sendMoney');
  const hasSendMoneyFeature = useIsSendMoneyAvailable();

  const kycCheck = useKycCheck();
  const hasAccess = usePermissions('business.directTransfer.create') && hasSendMoneyFeature;
  if (!hasAccess) return <NoPermission />;
  if (!kycCheck.isCompleted) return <KycContent {...kycCheck} />;
  return (
    <>
      <div className="SendMoneyPage">
        <Row gutter={gutter}>
          <Col span={24}>
            <PageHeader heading={t('sendMoney')} showSearch={false} />
          </Col>
        </Row>
        <div>
          <SendMoneyView />
        </div>
      </div>
    </>
  );
};

const gutter: [number, number] = [16, 24];

// export const sendMoneyResourceKey = 'sendMoney';

export default SendMoney;
